<template>
  <modal :value="value" max-width="450" :has-padding="false" @input="emitInput">
    <div class="integration-failed-attempts-list-item-message-modal-wrapper">
      <h2 class="modal-title text-center text-heading">{{ title }}</h2>
      <div>
        <div v-if="isErrorMessage" class="error-message-wrapper">
          <div v-html="failMessage" ref="failMessage"></div>
        </div>
        <div v-else class="content-message-wrapper">
          <ul class="parent-list">
            <li>
              <span class="parent-list-item-title"
                >{{
                  $t("message.integrations.message.establishmentDetails")
                }}:</span
              >
              <ul class="child-list">
                <li>
                  {{ $t("message.generics.message.name") }}:
                  <span>{{
                    formattedData.establishment.establishmentName
                  }}</span>
                </li>
                <li>
                  {{ $t("message.spots.message.device") }}:
                  <span>{{ formattedData.establishment.accessPointName }}</span>
                </li>
              </ul>
            </li>
            <li class="parent-list-item">
              <span class="parent-list-item-title"
                >{{ $t("message.integrations.message.accessData") }}:</span
              >
              <ul class="child-list">
                <li>
                  {{ $t("message.integrations.message.accessDate") }}:
                  <span>{{ clientAccessDate }}</span>
                </li>
                <li>
                  {{ $t("message.integrations.message.accessId") }}:
                  <span>{{ formattedData.access.accessId }}</span>
                </li>
              </ul>
            </li>
            <li class="parent-list-item">
              <span class="parent-list-item-title"
                >{{ $t("message.integrations.message.userData") }}:</span
              >
              <ul class="child-list">
                <li>
                  ID:
                  <span>{{ formattedData.client.clientId }}</span>
                </li>
                <li v-for="(value, index) in clientData" :key="index">
                  <span>{{ value }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import { cloneDeep } from "lodash";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      show: false,
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: String,
    },
    type: {
      type: String,
    },
  },

  computed: {
    title() {
      return this.isErrorMessage
        ? this.$t("message.integrations.message.error")
        : this.$t("message.integrations.message.content");
    },
    isErrorMessage() {
      return this.type === "error";
    },
    formattedData() {
      return this.isErrorMessage ? this.data : JSON.parse(this.data);
    },
    clientAccessDate() {
      return this.$date.format(this.formattedData.access.accessDate);
    },
    clientData() {
      const clientDataObj = cloneDeep(this.formattedData.client);
      delete clientDataObj.clientId;
      return Object.values(clientDataObj);
    },
    failMessage() {
      if (!this.data) return "<p>Sem conteúdo</p>";

      let failMessage;
      const isHTMLString =
        this.data.includes("<html") && this.data.includes("<body");

      if (isHTMLString) {
        const parser = new DOMParser();
        const html = parser.parseFromString(this.data, "text/html");
        const htmlTitle = html.querySelector("title").textContent;
        failMessage = htmlTitle
          ? `<p>O erro retornado veio como um documento HTML genérico com o seguinte título:</p><p style="text-align:center"><strong>${htmlTitle}</strong></p>`
          : "<p>O erro retornado veio como um documento HTML genérico sem título</p>";
      } else {
        failMessage = this.data;
      }

      return failMessage;
    },
  },

  methods: {
    closeModal() {
      this.show = false;
    },
    emitInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.integration-failed-attempts-list-item-message-modal-wrapper {
  padding: 10px !important;

  .modal-title {
    margin-bottom: 12px;
  }

  .error-message-wrapper {
    padding-left: 24px;
  }

  .content-message-wrapper {
    .parent-list {
      list-style: none;

      .parent-list-item-title {
        font-weight: bold;
      }

      .child-list {
        list-style: inside;
      }
    }
  }
}
</style>
